import { deviceType } from "@tm/isomorphic-utils";
import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const Container = styled.section`
  background: ${theme.whiteText};
  border-radius: 16px;
  padding: 32px;
  width: 100%;
  box-sizing: border-box;

  @media ${deviceType.mobile} {
    padding: 20px 16px;
    border-radius: 12px;
  }
`;

export const BenefitsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const BenefitCard = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 0 0 calc(33.333% - 11px);
  max-width: calc(33.333% - 11px);
  min-width: 0;
  height: 90px;
  padding: 24px 32px;
  background: ${theme.whiteText};
  border: 1px solid ${theme.disabledGrey2};
  border-radius: 16px;
  box-sizing: border-box;
  overflow: hidden;

  img {
    object-fit: contain;
    flex-shrink: 0;
  }

  @media ${deviceType.mobile} {
    flex: 1 0 100%;
    height: auto;
    padding: 16px;
    gap: 16px;
  }
`;

export const BenefitTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;
